import { IconProps, iconColor } from './IconProps'

export function PercentIcon(props: IconProps): JSX.Element {
  const size = props.size || 24

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 25 24'
      fill='none'
    >
      <path
        d='M5.77473 18.918L19.9043 4.78848M15.4116 19.0083C16.5821 20.1809 18.4798 20.1809 19.6503 19.0083C20.8208 17.8356 20.8208 15.9343 19.6503 14.7617C18.4798 13.589 16.5821 13.589 15.4116 14.7617C14.2411 15.9343 14.2411 17.8356 15.4116 19.0083ZM5.46351 9.23835C6.63399 10.411 8.53172 10.411 9.70221 9.23835C10.8727 8.06569 10.8727 6.16443 9.70221 4.99177C8.53172 3.81911 6.63399 3.81911 5.46351 4.99177C4.29303 6.16443 4.29303 8.06569 5.46351 9.23835Z'
        stroke={iconColor(props)}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
